import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { FleetMaintenanceRule } from '../../../types/fleet';
import { FleetMaintenanceRuleForm } from './FleetMaintenanceRuleForm';

type Props = {
  isOpen: boolean;
  selectedMaintenanceRule?: FleetMaintenanceRule;
  onClose: (update?: boolean) => void;
};

function FleetMaintenanceRuleModal({ onClose, isOpen, selectedMaintenanceRule }: Props) {
  const { css } = useStyles();
  const [maintenanceRule, setMaintenanceRule] = useState<FleetMaintenanceRule>();

  useEffect(() => {
    if (!selectedMaintenanceRule) {
      setMaintenanceRule(undefined);
      return;
    } else {
      setMaintenanceRule(selectedMaintenanceRule);
    }
  }, [selectedMaintenanceRule]);

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
          })}
        >
          {maintenanceRule?.name ?? 'Nueva regla'}
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          <FleetMaintenanceRuleForm
            maintenanceRule={maintenanceRule}
            onCancel={() => onClose(false)}
            afterSave={() => onClose(true)}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(FleetMaintenanceRuleModal);
